import axios from '@/jslib/axios'

export const getOrderDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/order/detail',
    params
  })
}

export const saveOrder = data => {
  return axios({
    method: 'post',
    url: '/admin/order/save',
    data,
    timeout: 60000
  })
}
//change by sz
export const saveReferCaseOrder = data => {
  return axios({
    method: 'post',
    url: '/admin/referral/order/save',
    data
  })
}


export const uploadOrderFile = (data,isEnquiry =false) => {
  let path = isEnquiry?'/admin/file/upload':'/admin/order/file/upload'
  return axios({
    method: 'post',
    url: path,
    headers: { 'Content-Type': 'multipart/form-data' },
    data,
    timeout: 120000
  })
}

export const paymentCheckout = data => {
  return axios({
    method: 'post',
    url: '/admin/payment/checkout',
    data
  })
}

export const applyOrderCode = data => {
  return axios({
    method: 'post',
    url: '/admin/order/code/apply',
    data
  })
}

export const getOrderList = (params,other) => {
  return axios({
    method: 'get',
    url: '/admin/order/list',
    params,
    ...other
  })
}

export const verifyPromoCode = data => {
  return axios({
    method: 'post',
    url: '/admin/promo_code/verify',
    data
  })
}

export const deleteOrderFile = data => {
  return axios({
    method: 'delete',
    url: '/admin/order/file/delete',
    data
  })
}
export const deleteExtraFile = data => {
  return axios({
    method: 'delete',
    url: '/admin/order/file/delete/extra',
    data
  })
}

export const deleteOrderDriverFile = data => {
  return axios({
    method: 'delete',
    url: '/admin/order/file/driver_del',
    data
  })
}
export const voidOrder = data => {
  return axios({
    method: 'post',
    url: '/admin/order/void',
    data
  })
}

export const voidPolicyOrder = data => {
  return axios({
    method: 'post',
    url: '/admin/order/void/policy',
    data
  })
}

export const orderTurnToNewPcy = data => {
  return axios({
    method: 'post',
    url: '/admin/order/turn_to_new_pcy',
    data
  })
}

export const issueOrderCvr = data => {
  return axios({
    method: 'post',
    url: '/admin/order/issue/cvr',
    data
  })
}

export const orderIssueIssuing = data => {
  return axios({
    method: 'post',
    url: '/admin/order/issue/issuing',
    data
  })
}

export const orderIssueComplete = data => {
  return axios({
    method: 'post',
    url: '/admin/order/issue/complete',
    data
  })
}

export const orderEnterPcyNo = data => {
  return axios({
    method: 'post',
    url: '/admin/order/enter/pcy_no',
    data
  })
}

export const completeNewBusinessOrder = data => {
  return axios({
    method: 'post',
    url: '/admin/order/complete/new/business',
    data
  })
}
export const setLockCustomer = data => {
  return axios({
    method: 'post',
    url: '/admin/order/lock/set',
    data
  })
}
export const setQuoteDiscount = data => {
  return axios({
    method: 'post',
    url: '/admin/order/discount/set',
    data
  })
}
export const setQuoteVoid = data => {
  return axios({
    method: 'post',
    url: '/admin/order/void/policy/cal',
    data
  })
}
export const setRefundCal = data => {
  return axios({
    method: 'post',
    url: '/admin/refund/cal',
    data
  })
}

export const getOrderPremiumData = params => {
  return axios({
    method: 'get',
    url: '/admin/order/premium/data',
    params
  })
}

export const sendOrderIssueIssuingNotice = data => {
  return axios({
    method: 'post',
    url: '/admin/order/issue/issuing/notice',
    data
  })
}

export const sendOrderEnterPcyNoNotice = data => {
  return axios({
    method: 'post',
    url: '/admin/order/enter/pcy_no/notice',
    data
  })
}

export const updateOrderFileCvr = data => {
  return axios({
    method: 'post',
    url: '/admin/order/file/cvr',
    data
  })
}

export const updateOrderFilePcy = data => {
  return axios({
    method: 'post',
    url: '/admin/order/file/pcy',
    data
  })
}
export const updateManualOrderFilePcy = data => {
  return axios({
    method: 'post',
    url: '/admin/order/file/manual/pcy',
    data
  })
}
export const updateOrderExtraPcy = data => {
  return axios({
    method: 'post',
    url: '/admin/order/file/extra',
    data
  })
}
export const updateOrderRgtn = data => {
  return axios({
    method: 'post',
    url: '/admin/order/file/rgtn/pic',
    data
  })
}
export const addCustomer = data => {
  return axios({
    method: 'post',
    url: '/admin/order/guest/add/customer',
    data
  })
}
export const getExtraCompute = data => {
  return axios({
    method: 'post',
    url: '/admin/extra/quote/new',
    data
  })
}
export const getOrderLogList = params => {
  return axios({
    method: 'get',
    url: '/admin/order/log/list',
    params
  })
}

export const RebuildPDF = data => {
  return axios({
    method: 'post',
    url: '/admin/rebuild/pdf',
    data
  })
}

export const orderReminder = data => {
  return axios({
    method: 'post',
    url: '/admin/order/upload/reminder',
    data
  })
}

export const getOrderReferralList = params => {
  return axios({
    method: 'get',
    url: '/admin/order/referral/options',
    params
  })
}
export const getPromoPreselect = params => {
  return axios({
    method: 'get',
    url: '/admin/promo/preselect',
    params
  })
}
export const getApiLogList = params => {
  return axios({
    method: 'get',
    url: 'admin/order/api/log/list',
    params
  })
}
export const setRenewStatus = data => {
  return axios({
    method: 'post',
    url: '/admin/order/renew/status/set',
    data
  })
}
export const sendQuoteReferrer = data => {
  return axios({
    method: 'post',
    url: '/admin/order/send/quote/referrer',
    data
  })
}
export const setMgmDiscount = data => {
  return axios({
    method: 'post',
    url: '/admin/order/edit/mgm/discount',
    data
  })
}
export const getClientPolicyDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/client/policy/detail/url',
    params
  })
}
export const changeOrderAgency = data => {
  return axios({
    method: 'post',
    url: '/admin/order/change/referrer/agency',
    data
  })
}
export const turnAutoRenewal = data => {
  return axios({
    method: 'post',
    url: '/admin/order/turn/auto/renewal',
    data
  })
}

export const searchQuoteDiscount = data => {
  return axios({
    method: 'post',
    url: '/admin/order/discount/calc',
    data
  })
}